import styled from 'styled-components';

export const ErrorContainer = styled.div`
  max-width: 438px;
`;
